import {router, matcher, docsRoute, withoutDocRoute, NOT_FOUND_ROUTE_NAME} from '../../routes';
import {sanitizeUrl} from '../../../@polygonjs/polygonjs/src/core/UrlHelper';
import {RouteLocationNormalizedLoaded} from 'vue-router';
import {DocsRoute} from '../pages/Pages';

export function replaceAnchorsByRouterLinks(element: HTMLElement, route: RouteLocationNormalizedLoaded) {
	const anchors = Array.from(element.getElementsByTagName('a'));
	for (let anchor of anchors) {
		_replaceAnchorByRouterLink(anchor, route);
	}
}
function _replaceAnchorByRouterLink(anchor: HTMLAnchorElement, route: RouteLocationNormalizedLoaded) {
	const url = anchor.getAttribute('href');
	if (!url) {
		return;
	}
	if (url.startsWith('http')) {
		return;
	}
	anchor.removeAttribute('href');
	const docifyUrl = docifyLink(url, route);
	if (!docifyUrl) {
		anchor.classList.add('bg-red-500');
		return;
	}
	anchor.classList.add('cursor-pointer');
	anchor.addEventListener('click', (e) => {
		e.preventDefault();
		console.log(url);
		router.push(url);
	});
}

function _isPathResolved(route: RouteLocationNormalizedLoaded, path: string): boolean {
	const matched = matcher.resolve({path: path}, route).matched;
	if (matched.length == 1 && matched[0].name == NOT_FOUND_ROUTE_NAME) {
		return false;
	}
	const result = matched.length > 0;
	return result;
}
export function docifyLink(href: string, route: RouteLocationNormalizedLoaded) {
	if (_isPathResolved(route, href)) {
		return href;
	}
	const withDoc = sanitizeUrl(docsRoute(href as DocsRoute));
	if (_isPathResolved(route, withDoc)) {
		return withDoc;
	}
	const withoutDoc = sanitizeUrl(withoutDocRoute(href as DocsRoute));
	if (_isPathResolved(route, withoutDoc)) {
		return withoutDoc;
	}
	console.error(`no match for link:${href}`);
}
